export const DOMAINS = {
  dev: 'dev',
  explore: 'explore',
  enterpriseExplore: 'enterpriseExplore',
  about: 'about',
  degrees: 'degrees',
} as const;
